import L from 'leaflet';

export function transformLayerToJson(layer) {
    const json = layer.toGeoJSON();
    if (layer instanceof L.Circle) {
        json.properties.radius = layer.getRadius();
    }
    return json;
}